import UserTermsPage from "./UserTermsPage";
export default UserTermsPage;
